import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";

import { appStore, customModuleStore } from "../../stores";
import { Popup } from "../common/Popup";
import { JsonSchemaForm } from "../JsonSchemaForm";
import { JsonSchema, ServiceParameters } from "../JsonSchemaForm/types";

export interface IModuleConfigurationSchemaFormProps {
    schemaUrl: string;
    configurationId?: string;
    overrideConfiguration?: string;
    onConfigurationChange: (config: string) => void;
    onCancel: () => void;
}

export const SimpleModuleConfigurationSchemaFormPopup: FC<
    IModuleConfigurationSchemaFormProps
> = (props: IModuleConfigurationSchemaFormProps) => {
    const {
        schemaUrl,
        onConfigurationChange,
        configurationId,
        overrideConfiguration,
        onCancel,
    } = props;
    const [loaded, setLoaded] = useState<boolean>(false);
    const [schema, setSchema] = useState<JsonSchema | undefined>(undefined);
    const [params, setParams] = useState<ServiceParameters>({});
    const [currentPath, setCurrentPath] = useState<string[]>([]);

    useEffect(() => {
        let isMounted = true;

        async function fetchData() {
            const actualUrl = schemaUrl;
            const response = await fetch(actualUrl);
            const schemaResult = (await response.json()) as JsonSchema;

            if (isMounted) {
                setSchema(schemaResult);
                if (overrideConfiguration) {
                    setParams(JSON.parse(overrideConfiguration));
                } else if (configurationId) {
                    const configuration =
                        await customModuleStore.getConfiguration(
                            configurationId,
                        );
                    const currentState = configuration?.configuration
                        ? JSON.parse(configuration?.configuration)
                        : {};
                    setParams(currentState);
                } else {
                    setParams({});
                }
                setLoaded(true);
            }
        }

        fetchData().catch(() => {
            appStore.setSnackbar(
                `Could not fetch module configuration: ${schemaUrl}`,
                undefined,
                "side",
            );
        });

        return () => {
            isMounted = false;
        };
    }, [schemaUrl, configurationId, overrideConfiguration]);
    return (
        <>
            {loaded && schema && params && (
                <Container>
                    <Popup visible={true} windowClassName="window">
                        <JsonSchemaForm
                            schema={schema}
                            params={params}
                            path={[]}
                            setParams={setParams}
                            currentPath={currentPath}
                            setCurrentPath={setCurrentPath}
                            onCancel={onCancel}
                            onSave={(config: string) => {
                                onConfigurationChange(config);
                            }}
                        />
                    </Popup>
                </Container>
            )}
        </>
    );
};

const Container = styled.div`
    .window {
        width: 22.5rem;
        min-width: 22.5rem;
        min-height: 33.8125rem;
        height: 33.8125rem;
        padding: 0rem;
        margin: 0rem;
    }
`;
